import React from 'react';
import { UserX, Search, Filter, AlertCircle, RefreshCw } from 'lucide-react';

const InactiveCustomers = () => {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>
            💤 Pasif Müşteriler
          </h1>
          <p style={{ color: '#6B7280' }}>Uzun süredir işlem yapmayan müşterileriniz</p>
        </div>
        <button style={{
          padding: '12px 24px',
          backgroundColor: '#F59E0B',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          boxShadow: '0 2px 8px rgba(245,158,11,0.3)'
        }}>
          <RefreshCw size={20} />
          Yeniden Aktifleme Kampanyası
        </button>
      </div>

      {/* Uyarı Kutusu */}
      <div style={{
        backgroundColor: '#FEF3C7',
        border: '1px solid #F59E0B',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '24px',
        display: 'flex',
        alignItems: 'start',
        gap: '12px'
      }}>
        <AlertCircle size={24} color="#F59E0B" />
        <div>
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#92400E', marginBottom: '4px' }}>
            30 Günden Uzun Süredir İşlem Yok
          </div>
          <div style={{ fontSize: '13px', color: '#78350F' }}>
            Bu müşterilerle iletişime geçerek yeniden aktif hale getirebilirsiniz.
          </div>
        </div>
      </div>

      {/* Arama ve Filtre */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '16px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        marginBottom: '24px',
        display: 'flex',
        gap: '12px'
      }}>
        <div style={{ flex: 1, position: 'relative' }}>
          <Search style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }} size={20} />
          <input
            type="text"
            placeholder="Pasif müşteri ara..."
            style={{
              width: '100%',
              padding: '10px 10px 10px 44px',
              border: '1px solid #E5E7EB',
              borderRadius: '8px',
              fontSize: '14px'
            }}
          />
        </div>
        <select style={{
          padding: '10px 16px',
          border: '1px solid #E5E7EB',
          borderRadius: '8px',
          fontSize: '14px',
          color: '#374151',
          cursor: 'pointer'
        }}>
          <option>Tüm Süreler</option>
          <option>30-60 gün</option>
          <option>60-90 gün</option>
          <option>90+ gün</option>
        </select>
      </div>

      {/* Pasif Müşteri Kartları */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '16px' }}>
        {[
          { name: 'Can Özdemir', company: 'Old Corp.', phone: '0555 666 7788', email: 'can@oldcorp.com', lastContact: '45 gün önce', inactiveDays: 45 },
          { name: 'Elif Arslan', company: 'Past Business', phone: '0555 777 8899', email: 'elif@past.com', lastContact: '67 gün önce', inactiveDays: 67 },
          { name: 'Emre Çelik', company: 'Former Ltd.', phone: '0555 888 9900', email: 'emre@former.com', lastContact: '93 gün önce', inactiveDays: 93 },
          { name: 'Gizem Yalçın', company: 'Previous Inc.', phone: '0555 999 0011', email: 'gizem@previous.com', lastContact: '38 gün önce', inactiveDays: 38 },
        ].map((customer, index) => (
          <div key={index} style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '20px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            borderLeft: '4px solid #EF4444',
            transition: 'all 0.2s',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)'}
          onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)'}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px' }}>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '4px' }}>
                  {customer.name}
                </h3>
                <p style={{ fontSize: '14px', color: '#6B7280' }}>{customer.company}</p>
              </div>
              <span style={{
                padding: '4px 12px',
                backgroundColor: '#FEE2E2',
                color: '#EF4444',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: '500'
              }}>
                {customer.inactiveDays} gün
              </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#6B7280' }}>
                <span>📞</span>
                <span>{customer.phone}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#6B7280' }}>
                <span>📧</span>
                <span>{customer.email}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#9CA3AF' }}>
                <span>🕐</span>
                <span>Son görüşme: {customer.lastContact}</span>
              </div>
            </div>
            <button style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#EFF6FF',
              border: '1px solid #3B82F6',
              borderRadius: '8px',
              color: '#3B82F6',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer'
            }}>
              İletişime Geç
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InactiveCustomers;